export const PALLET_PRICE_LABELS: { [key: string]: string } = {
   EDHP_PALLET: 'edhpPalletPrice',
   EURO_PALLET: 'euroPalletPrice',
   HALF_PALLET_NDHP: 'halfPalletNDHPPrice',
   QUARTER_PALLET_CDHP: 'quarterPalletCDHPPrice',
};
